import GrayBtn from "../../Atoms/Buttons/GrayBtn";
import styled from "styled-components";
import useMediaQuery from "../../../Hooks/useMediaQuery";
import {ReactComponent as Icon} from './InfoIcon.svg';


const Container = styled.div`
  margin: auto;
  width: 328px;
  display: flex;
  flex-direction: column;
  align-item: center;

  div {
    margin-bottom: 12px;
  }
`
export default ({selections, click, btnSize}) => {
  const toggleActive = (e) => {
    if (e.currentTarget.classList.contains("btn-container")) {
      e.currentTarget.childNodes.forEach(child => {
        child.classList.remove("active")
      })
    }

    if (e.target.classList.contains("btn")) {
      e.target.classList.add("active");
    }
  }

  return (
    <Container className={"btn-container"} onClick={toggleActive}>
      {selections.map((selection, idx) =>
        <GrayBtn short={btnSize === "short"} key={selection.text + String(idx)}
                 onClick={click} data-index={selection.nextIndex} data-log={selection.name}
                 className={"btn"}>
          {selection.text}
        </GrayBtn>)
      }
    </Container>
  )
}